<script setup>
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import UserCardSocialLinks from "./UserCardSocialLinks.vue";

const props = defineProps({
  joinedAt: { type: String, default: null },
  socials: { type: Object, default: () => ({}) },
});

const { t } = useI18n();

const formattedJoined = computed(() => {
  if (!props.joinedAt) return null;
  const d = new Date(props.joinedAt);
  if (Number.isNaN(d.getTime())) return null;
  return d.toLocaleDateString(undefined, {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
});
</script>

<template>
  <div
    v-if="formattedJoined || (socials && Object.keys(socials).length)"
    class="flex items-center justify-between gap-3"
  >
    <div v-if="formattedJoined" class="text-xs text-muted-foreground truncate">
      {{ t("Joined on") }} {{ formattedJoined }}
    </div>
    <div v-else />
    <UserCardSocialLinks :socials="socials" />
  </div>
</template>
